import React, { Component } from "react";
import Select from "react-select";
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { SkyLightStateless } from 'react-skylight';

const propTypes = {
  selectedOrders: PropTypes.array
}

const defaultProps = {
  selectedOrders: []
}

const modalStyle = {
  width: '600px',
  height: '200px',
  marginLeft: '-10%'
}

export class BatchesModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedBatch: {
        label: 'default',
        value: null,
      },
      batchSelection: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.batchesInfo.batches !== nextProps.batchesInfo.batches) {
      this.setState({
        batchSelection: this.processBatchSelection(nextProps.batchesInfo.batches),
      })
    }
  }
  handleOnSubmit = (e) => {
    const {
      selectedBatch,
    } = this.state;
    const batch = selectedBatch.value ? selectedBatch : this.state.batchSelection[0];
    
    this.props.onSelectedBatch(batch.value, batch.expiredDate, batch.palletBarcode);
  };

  handleBatchSelected = (selectedBatch) => this.setState({ selectedBatch });

  processBatchSelection = (batches = []) => {
    let avaliableBatches = batches.filter(batch => {
      if (this.props.salesOrderProduct!==null){
        if (batch.quantity <= 0 && !this.props.salesOrderProduct.IsOverSaleable) {
          return false;
        }
      }
      return true;
    });
    avaliableBatches = avaliableBatches.sort((a, b) => {
      if (a.expire_datetime > b.expire_datetime) {
        return 1
      } 
      return -1
    });
    avaliableBatches = avaliableBatches.map(batch => ({ 
      label: `  
        ${batch.batch_num}: ${batch.inventory_qty}
        ${batch.location 
          ? `- Location: ${batch.location}` 
          : '- Location: N/A'}
        ${batch.pallet_barcode 
          ? `- PLT barcode: ${batch.pallet_barcode}` 
          : '- PLT barcode: N/A'}`,
      value: batch.id,
      expiredDate: batch.expire_datetime,
      palletBarcode: batch.pallet_barcode,
    }));
    return avaliableBatches;
  }

  render() {
    const {
      selectedBatch,
    } = this.state;
    const {
      setModalVisibility,
      isVisible,
    } = this.props;
    // const batchSelection = this.processBatchSelection(this.props.batchesInfo.batches);

    return (
      <SkyLightStateless
        title={'Select Batch'}
        onCloseClicked={setModalVisibility}
        dialogStyles={modalStyle}
        isVisible={isVisible}
      >
        <div>
          <Row style={{ marginBottom: "12px" }}>
            <Col sm={3}>
              <label style={{ float: 'right' }}>
                <Translate value="selecte_batch" />:
              </label>
            </Col>
            <Col sm={9}>
              <Dropdown>
                <Dropdown.Toggle
                  style={{
                    width: "400px",
                    backgroundColor: "white",
                    border: "1px solid #555555",
                    color: "black",
                    fontWeight: "400",
                  }}
                >
                  {selectedBatch.label || selectedBatch}
                </Dropdown.Toggle>
                <Dropdown.Menu className="super-colors">
                  {this.state.batchSelection.map((batch) => {
                    return (
                      <MenuItem onClick={() => this.handleBatchSelected(batch)} style={{
                        width: "400px",
                        backgroundColor: "white",
                        color: "black",
                        fontWeight: "400",
                      }}>
                        {batch.label}
                      </MenuItem>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>

          <Row className="centerStyle" style={{ marginTop: "50px" }}>
            <Button
              bsStyle="success"
              onClick={(e) => {
                this.handleOnSubmit(e);
              }}
            >
              <Translate value="select_this_batch" />
            </Button>
          </Row>
        </div>
      </SkyLightStateless>
    );
  }
}

BatchesModal.propTypes = propTypes
BatchesModal.defaultProps = defaultProps

export default BatchesModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/BatchesModal.jsx